import { slugify } from "./slugify";

export type TocEntry = { id: string; text: string; level: 2 | 3 };

export function buildToc(
  sections: { type: string; text?: string }[],
): TocEntry[] {
  return sections
    .filter((s) => (s.type === "h2" || s.type === "h3") && !!s.text)
    .map((s) => ({
      id: slugify(s.text as string),
      text: s.text as string,
      level: s.type === "h2" ? 2 : 3,
    }));
}
